document.querySelectorAll(".header__inline-menu details").forEach((item) => {
            item.addEventListener("mouseover", () => {
                item.setAttribute("open", "");
            }),
                item.addEventListener("mouseleave", () => {
                    item.removeAttribute("open");
                });
            const ulElement = item.querySelector("ul");
            ulElement &&
                ulElement.addEventListener("mouseleave", () => {
                    item.removeAttribute("open");
                });
        });